import React, { useState, useEffect } from 'react';

import { withRouter } from '@atlassian/react-resource-router';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { getHealthcheck } from '../rest/index.tsx';
import type { Healthcheck } from '../common/types.tsx';
import { LOG_LOCATION } from '../common/constants.tsx';
import HealthcheckPageContents from './main.tsx';

export const HealthcheckPage = () => {
	const [healthcheck, setHealthcheck] = useState<Healthcheck | null>(null);

	useEffect(() => {
		getHealthcheck()
			.then((data) => {
				setHealthcheck(data);
			})
			.catch((err) => {
				log.safeErrorWithoutCustomerData(LOG_LOCATION, 'Failed to fetch healthcheck data', err);
				setHealthcheck(null);
			});
	}, []);

	return <HealthcheckPageContents healthcheck={healthcheck} />;
};

export default withRouter(HealthcheckPage);
